class AddProductCartCollection extends HTMLElement{
    constructor() {
      super();
      this.addEventListener('click', async (event) => {
        await this.addProductCart(event.target.dataset.idVariant, event);
      })
    }

    addProductCart = async (variant_id, element) => {
      console.log(element.target);
      element.target.children[1].style.display = "block";
      
      let formData = {
       'items': [{
        'id': variant_id,
        'quantity': 1
        }]
      };

      const responsePostCart = await fetch("/cart/add.js", { method: "POST", headers: {'X-Requested-With': 'XMLHttpRequest','Content-Type': 'application/json;'}, body: JSON.stringify(formData)});

      if(responsePostCart.status == 200){
        element.target.children[1].style.display = "none";
        window.location.href = "/cart";
      }else{
        element.target.children[1].style.display = "none";
        element.target.children[0].style.display = "flex";
        setTimeout(function(){
          element.target.children[0].style.display = "none";
        },3000)
      }
    }
}

customElements.define('button-add-product', AddProductCartCollection);